// Guide/article data. Central list of supporting guide routes + one full sample
// guide used to demonstrate the reusable guide template.

export const GUIDE_ROUTES = [
  { slug: "is-plastic-surgery-in-vietnam-safe", title: "Is Plastic Surgery in Vietnam Safe?" },
  { slug: "how-to-choose-a-plastic-surgeon-in-vietnam", title: "How to Choose a Plastic Surgeon in Vietnam" },
  { slug: "how-to-check-a-plastic-surgeon-licence-vietnam", title: "How to Check a Plastic Surgeon's Licence" },
  { slug: "plastic-surgery-vietnam-vs-thailand", title: "Plastic Surgery: Vietnam vs Thailand" },
  { slug: "plastic-surgery-vietnam-vs-south-korea", title: "Plastic Surgery: Vietnam vs South Korea" },
  { slug: "recovery-after-plastic-surgery-vietnam", title: "Recovery After Plastic Surgery in Vietnam" },
  { slug: "how-long-to-stay-in-vietnam-after-surgery", title: "How Long to Stay in Vietnam After Surgery" },
  { slug: "hospital-vs-cosmetic-clinic-vietnam", title: "Hospital vs Cosmetic Clinic in Vietnam" },
  { slug: "what-is-included-in-plastic-surgery-cost", title: "What Is Included in Plastic Surgery Cost" },
  { slug: "flying-after-plastic-surgery", title: "Flying After Plastic Surgery" },
];

// Fully-populated sample guide demonstrating the guide template.
export const SAMPLE_GUIDE = {
  slug: "is-plastic-surgery-in-vietnam-safe",
  title: "Is Plastic Surgery in Vietnam Safe?",
  summary:
    "Safety is not decided by a country. It depends on the individual surgeon, the facility, anaesthesia, your own health, the specific procedure and the quality of your aftercare.",
  image:
    "https://images.unsplash.com/photo-1764084455648-521862e715e5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  sections: [
    {
      h2: "Safety depends on specifics, not the country",
      body: "It is not accurate to say plastic surgery in any country is simply 'safe' or 'unsafe'. Outcomes are shaped by the surgeon's training and licensing, the standards of the operating facility, the anaesthesia team, your individual health, the complexity of the procedure and how carefully aftercare is managed.",
    },
    {
      h2: "Questions that help you assess safety",
      body: "Ask where surgery will take place and whether the facility is appropriately licensed. Ask about the surgeon's credentials and how to verify them. Ask how complications would be handled and what follow-up is available if you travel home.",
    },
    {
      h2: "Realistic expectations reduce disappointment",
      body: "No responsible professional guarantees results. A good consultation discusses realistic outcomes, limitations and the possibility that a revision may sometimes be needed. Slowing down and comparing suitable options is part of a safe decision.",
    },
    {
      h2: "How Plastic Surgery Vietnam supports safety",
      body: "We coordinate information so you can make an informed decision. We help review provider licensing, confirm the operating location and organise direct consultations. All clinical decisions remain with licensed medical professionals.",
    },
  ],
  relatedGuides: [
    "how-to-choose-a-plastic-surgeon-in-vietnam",
    "how-to-check-a-plastic-surgeon-licence-vietnam",
    "recovery-after-plastic-surgery-vietnam",
  ],
};
